import { printf, toText } from "./fable_modules/fable-library.3.7.20/String.js";
import { decimal as decimal_1, uint64 as uint64_1, int64 as int64_1, fail } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { UTC_ofDateTime_7F9DDECF, UTCModule_yyyy_MM_ddTHH_mm_ssZ } from "./fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { DateOnlyExtensions_yyyy_MM_dd, parseDateTime } from "./Utils.js";
import { toUniversalTime } from "./fable_modules/fable-library.3.7.20/Date.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.20/Choice.js";
import { decimal, uint64, int64 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { DateModule_ofDateTime } from "./Svea.Dry/Time.js";
import { newGuid } from "./fable_modules/fable-library.3.7.20/Guid.js";
import { add } from "./fable_modules/fable-library.3.7.20/Map.js";
import { empty } from "./fable_modules/Thoth.Json.10.2.0/Extra.fs.js";
import { ExtraCoders } from "./fable_modules/Thoth.Json.10.2.0/Types.fs.js";

export function generateEncoder(name, _arg) {
    return toText(printf("%s function"))(name);
}

export function generateDecoder() {
    return (path) => ((arg20$0040) => fail("not supported", path, arg20$0040));
}

export function utcEncoder(utc) {
    return UTCModule_yyyy_MM_ddTHH_mm_ssZ(utc);
}

export function utcDecoder(path, value) {
    const matchValue = parseDateTime(value);
    if (matchValue == null) {
        return fail("not supported", path, value);
    }
    else {
        const matchValue_1 = UTC_ofDateTime_7F9DDECF(toUniversalTime(matchValue));
        if (matchValue_1 == null) {
            return fail("not supported", path, value);
        }
        else {
            return new FSharpResult$2(0, matchValue_1);
        }
    }
}

export function int64Encoder(number) {
    return int64(number);
}

export function int64Decoder() {
    return (arg) => {
        const clo = int64_1(arg);
        return clo;
    };
}

export function uint64Encoder(number) {
    return uint64(number);
}

export function uint64Decoder() {
    return (arg) => {
        const clo = uint64_1(arg);
        return clo;
    };
}

export function decimalEncoder(number) {
    return decimal(number);
}

export function decimalDecoder() {
    return (path) => ((value) => decimal_1(path, value));
}

export function dateEncoder(date) {
    return DateOnlyExtensions_yyyy_MM_dd(date);
}

export function dateDecoder(path, value) {
    const matchValue = parseDateTime(value);
    if (matchValue == null) {
        return fail("not supported", path, value);
    }
    else {
        return new FSharpResult$2(0, DateModule_ofDateTime(matchValue));
    }
}

export function functionEncoder(name, _arg) {
    return toText(printf("[Function] %s"))(name);
}

export function functionDecoder() {
    return (path) => ((arg20$0040) => fail("not supported", path, arg20$0040));
}

export const extraCoders = (() => {
    let copyOfStruct, copyOfStruct_1, copyOfStruct_2, copyOfStruct_3, copyOfStruct_4, copyOfStruct_5, copyOfStruct_6, copyOfStruct_7, copyOfStruct_8, copyOfStruct_9, copyOfStruct_10, copyOfStruct_11, copyOfStruct_12, copyOfStruct_13, copyOfStruct_14, copyOfStruct_15, copyOfStruct_16, copyOfStruct_17, copyOfStruct_18, copyOfStruct_19, copyOfStruct_20, copyOfStruct_21;
    let extra_63;
    let extra_60;
    let extra_57;
    let extra_54;
    let extra_51;
    let extra_48;
    let extra_45;
    let extra_42;
    let extra_39;
    let extra_36;
    let extra_33;
    let extra_30;
    let extra_27;
    let extra_24;
    let extra_21;
    let extra_18;
    let extra_15;
    let extra_12;
    let extra_9;
    let extra_6;
    let extra_3;
    const decoder = generateDecoder();
    extra_3 = (new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Invoicee.PeppolId,System.String]]", [(arg10$0040) => generateEncoder("PeppolId", arg10$0040), decoder], empty.Coders)));
    const decoder_3 = generateDecoder();
    extra_6 = (new ExtraCoders((copyOfStruct_1 = newGuid(), copyOfStruct_1), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Common.String40,System.String]]", [(arg10$0040_1) => generateEncoder("String40", arg10$0040_1), decoder_3], extra_3.Coders)));
    const decoder_6 = generateDecoder();
    extra_9 = (new ExtraCoders((copyOfStruct_2 = newGuid(), copyOfStruct_2), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Invoicee.OrganisationNumber,System.String]]", [(arg10$0040_2) => generateEncoder("OrganisationNumber", arg10$0040_2), decoder_6], extra_6.Coders)));
    const decoder_9 = generateDecoder();
    extra_12 = (new ExtraCoders((copyOfStruct_3 = newGuid(), copyOfStruct_3), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Invoicee.CustomerGroupCode,System.String]]", [(arg10$0040_3) => generateEncoder("CustomerGroupCode", arg10$0040_3), decoder_9], extra_9.Coders)));
    const decoder_12 = generateDecoder();
    extra_15 = (new ExtraCoders((copyOfStruct_4 = newGuid(), copyOfStruct_4), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Common.String32OrEmpty,System.String]]", [(arg10$0040_4) => generateEncoder("String32", arg10$0040_4), decoder_12], extra_12.Coders)));
    const decoder_15 = generateDecoder();
    extra_18 = (new ExtraCoders((copyOfStruct_5 = newGuid(), copyOfStruct_5), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Common.String40OrEmpty,System.String]]", [(arg10$0040_5) => generateEncoder("String40OrEmpty", arg10$0040_5), decoder_15], extra_15.Coders)));
    const decoder_18 = generateDecoder();
    extra_21 = (new ExtraCoders((copyOfStruct_6 = newGuid(), copyOfStruct_6), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Common.String12OrEmpty,System.String]]", [(arg10$0040_6) => generateEncoder("String12OrEmpty", arg10$0040_6), decoder_18], extra_18.Coders)));
    const decoder_21 = generateDecoder();
    extra_24 = (new ExtraCoders((copyOfStruct_7 = newGuid(), copyOfStruct_7), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Common.String30OrEmpty,System.String]]", [(arg10$0040_7) => generateEncoder("String30OrEmpty", arg10$0040_7), decoder_21], extra_21.Coders)));
    const decoder_24 = generateDecoder();
    extra_27 = (new ExtraCoders((copyOfStruct_8 = newGuid(), copyOfStruct_8), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Invoicee.ContactNumber,System.String]]", [(arg10$0040_8) => generateEncoder("ContactNumber", arg10$0040_8), decoder_24], extra_24.Coders)));
    const decoder_27 = generateDecoder();
    extra_30 = (new ExtraCoders((copyOfStruct_9 = newGuid(), copyOfStruct_9), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Invoicee.Email,System.String]]", [(arg10$0040_9) => generateEncoder("Email", arg10$0040_9), decoder_27], extra_27.Coders)));
    const decoder_30 = generateDecoder();
    extra_33 = (new ExtraCoders((copyOfStruct_10 = newGuid(), copyOfStruct_10), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Invoicee.PostalAttention,System.String]]", [(arg10$0040_10) => generateEncoder("PostalAttention", arg10$0040_10), decoder_30], extra_30.Coders)));
    const decoder_33 = generateDecoder();
    extra_36 = (new ExtraCoders((copyOfStruct_11 = newGuid(), copyOfStruct_11), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Common.AlphaNumeric40,System.String]]", [(arg10$0040_11) => generateEncoder("AlphaNumeric40", arg10$0040_11), decoder_33], extra_33.Coders)));
    const decoder_36 = generateDecoder();
    extra_39 = (new ExtraCoders((copyOfStruct_12 = newGuid(), copyOfStruct_12), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Common.Number8,System.String]]", [(arg10$0040_12) => generateEncoder("Number8", arg10$0040_12), decoder_36], extra_36.Coders)));
    const decoder_39 = generateDecoder();
    extra_42 = (new ExtraCoders((copyOfStruct_13 = newGuid(), copyOfStruct_13), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Invoicee.ZipCode,System.String]]", [(arg10$0040_13) => generateEncoder("ZipCode", arg10$0040_13), decoder_39], extra_39.Coders)));
    const decoder_42 = generateDecoder();
    extra_45 = (new ExtraCoders((copyOfStruct_14 = newGuid(), copyOfStruct_14), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Invoicee.City,System.String]]", [(arg10$0040_14) => generateEncoder("City", arg10$0040_14), decoder_42], extra_42.Coders)));
    const decoder_45 = generateDecoder();
    extra_48 = (new ExtraCoders((copyOfStruct_15 = newGuid(), copyOfStruct_15), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.FSharpResult`2[Validation.Common.EmptyOrRange1To31,System.String]]", [(arg10$0040_15) => generateEncoder("EmptyOrRange1To31", arg10$0040_15), decoder_45], extra_45.Coders)));
    const decoder_48 = functionDecoder();
    extra_51 = (new ExtraCoders((copyOfStruct_16 = newGuid(), copyOfStruct_16), add("Microsoft.FSharp.Core.FSharpFunc`2[System.String,Microsoft.FSharp.Core.Unit]", [(arg10$0040_16) => functionEncoder("string -\u003e unit", arg10$0040_16), decoder_48], extra_48.Coders)));
    extra_54 = (new ExtraCoders((copyOfStruct_17 = newGuid(), copyOfStruct_17), add("Svea.Dry.Time.UTC", [utcEncoder, (path) => ((value_17) => utcDecoder(path, value_17))], extra_51.Coders)));
    const decoder_54 = uint64Decoder();
    extra_57 = (new ExtraCoders((copyOfStruct_18 = newGuid(), copyOfStruct_18), add("System.UInt64", [uint64Encoder, decoder_54], extra_54.Coders)));
    const decoder_57 = int64Decoder();
    extra_60 = (new ExtraCoders((copyOfStruct_19 = newGuid(), copyOfStruct_19), add("System.Int64", [int64Encoder, decoder_57], extra_57.Coders)));
    extra_63 = (new ExtraCoders((copyOfStruct_20 = newGuid(), copyOfStruct_20), add("System.DateOnly", [dateEncoder, (path_1) => ((value_21) => dateDecoder(path_1, value_21))], extra_60.Coders)));
    const decoder_63 = decimalDecoder();
    return new ExtraCoders((copyOfStruct_21 = newGuid(), copyOfStruct_21), add("System.Decimal", [decimalEncoder, decoder_63], extra_63.Coders));
})();

